import React, { useEffect, useState } from 'react';
import { ActionButton, LogoButton, } from '../../common/Buttons/Buttons';
import logo from '../../../images/logo.svg';
import canje from '../../../images/canje.svg';
import { capitalize, returnIGTF, NaNtoNumber } from '../../../assets/helpers/funciones.js';
import { useHistory } from "react-router-dom"
import moment from 'moment';
import './Login.scss';

export const ConfirmedPayment = () => {

  const [payment, setPayment] = useState('');
  const [vehicle, setVehicle] = useState('');
  const history = useHistory();

  const preloadData = () => {
    let paymentData = sessionStorage.getItem('payment');
    let vehicleData = sessionStorage.getItem('vehicle');
    paymentData = JSON.parse(paymentData);
    vehicleData = JSON.parse(vehicleData);

    setPayment(paymentData);
    setVehicle(vehicleData);
  };

  const finish = () => {
    sessionStorage.removeItem('personalData');
    sessionStorage.removeItem('payment');
    sessionStorage.removeItem('vehicle');
    history.push("/")
  };

  useEffect(() => {
    preloadData();
  }, []);


  return (
    <>

      <div className="container view-content">
        <form>
          <div className="row">
            <div className="col-12 login-page-container">

              <div className="login-form">
                <div className="login-logo-container">
                  <LogoButton link={'/'} src={logo} />
                  <h5 style={{ marginTop: "24px" }}>Renovación de Plan </h5>
                </div>
                <>
                  <div className="row">
                    <div style={{ textAlign: "center" }}>
                      <img style={{ height: "46px" }} src={canje} alt="" />
                      <h2>Renovación exitosa!</h2>
                    </div>
                    <br />
                    <div className="purchase-container">
                      <PurchaseSection
                        label={'FECHA DEL DESPACHO'}
                        text={moment.utc(new Date()).format('DD-MM-YYYY')}
                      />
                      <PurchaseSection
                        label={'Nombre'}
                        text={`${vehicle?.customer?.firstName}  ${vehicle?.customer?.lastName}`}
                      />
                      <PurchaseSection label={'E-mail'} text={`${vehicle?.customer?.email}`} />
                      {/* <PurchaseSection
                        label={'Dirección'}
                        text={`${capitalize(vehicle?.stateName)}, ${capitalize(
                          vehicle?.cityName
                        )}, ${capitalize(vehicle?.municipalityName)} ${capitalize(
                          vehicle?.address
                        )}`}
                      />{' '} */}
                      <PurchaseSection
                        label={'Vehículo '}
                        text={`${capitalize(vehicle?.model)} ${capitalize(vehicle?.brand)} ${vehicle?.year} ${vehicle?.color} ${vehicle?.plate}`}
                      />
                      {payment && (
                        <div>
                          <PurchaseSection
                            label={'Tipo de pago'}
                            text={`${payment?.paymentType}`}
                          />
                          <PurchaseSection
                            label={'CANTIDAD DE PAGOS'}
                            text={payment?.allPayments?.length}
                          />
                          <PaymentSection
                            label={'MEDIO DE PAGO'}
                            payments={payment?.allPayments}
                          />
                          <TotalSection label={'TOTAL'} payments={payment?.payments} />
                        </div>
                      )}
                    </div>


                  </div>
                  <div
                    className="buttons-center-container"
                    style={{ margin: '48px 0px 48px 0px' }}
                  >
                    <ActionButton label={'Finalizar'} action={finish} />
                  </div>
                </>

              </div>
            </div>
          </div>
        </form>

      </div>

    </>
  );
};


export const PurchaseSection = (props) => {
  const { label, text } = props;

  if (label && text) {
    return (
      <div className="purchase-section-component">
        <h6>{label}</h6>
        <h6>{text}</h6>
      </div>
    );
  } else return null;
};

export const TotalSection = (props) => {
  const { label, payments } = props;

  let totalPrice = 0;
  let iftg = false;

  // if (payments?.length > 1) {
  for (let i = 0; i < payments.length; i++) {
    if (payments[i]?.igtf) {
      totalPrice = totalPrice + (parseFloat(payments[i]?.amount) + NaNtoNumber(parseFloat(payments[i]?.amountIGTF)));
      parseFloat(payments[i]?.amount);
      iftg = true;
    } else {
      totalPrice = totalPrice + parseFloat(payments[i]?.amount);
    }
    // }
  }
  totalPrice = totalPrice.toFixed(2);

  if (label && payments) {
    return (
      <div className="purchase-section-component">
        <h6>{label}</h6>
        <h6>
          ${totalPrice} {iftg ? ` Incluye IGTF (${returnIGTF()}%)` : ''}
        </h6>
      </div>
    );
  } else return null;
};


export const PaymentSection = (props) => {
  const { label, payments } = props;

  const returnAmmount = (payment) => {
    return "$" + (parseFloat(payment?.amount) + NaNtoNumber(parseFloat(payment?.amountIGTF)))
  }

  if (label && payments) {
    return (
      <div className="purchase-section-component">
        <h6>{label}</h6>
        {/* <h6>{payments?.map()}</h6> */}
        <h6 style={{ textAlign: 'right' }}>
          {payments?.map((p) => (
            <span key={p?.method}>
              {capitalize(p?.methodName) +
                '  ' +
                (p?.currency === 'BsS'
                  ? p?.amountBsS + ' ' + p?.currency
                  : returnAmmount(p))}
              <br></br>
            </span>
          ))}
        </h6>
      </div>
    );
  } else return null;
};
